@layer module {
.row-details {
            display: grid;
            grid-template-rows: 0fr;
            padding: 0;
    }

.row-details[data-open='true'] {
            grid-template-rows: 1fr;
    }

.row-details__inner {
            min-height: 0;
            overflow: hidden;
    }
} // layer module










@layer app {
.row-details {
            opacity: 0;
            transition: grid-template-rows 0.25s ease, opacity 0.25s ease;
    }

.row-details[data-open='true'] {
            opacity: 1;
    }
} // layer app
